<template>
  <div class="object-card">
    <fetch-json :url="url">
      <template slot-scope="{ json: mappings, loading }">
        <custom-scroll v-if="!loading && mappings">
          <div class="object-card-content">
            <h4 class="title is-5">{{ feature.fullName | emptyName }}</h4>
            <h6 class="subtitle is-6">{{ feature.layerDisplayName }}</h6>
            <Property
              v-for="(prop, index) in feature.mappingProperties(mappings)"
              :key="index"
              :name="prop.name"
              :value="prop.value"
              :title="prop.title"
            ></Property>
          </div>
        </custom-scroll>
      </template>
    </fetch-json>
  </div>
</template>
<script>
import Property from "@/components/common/Property";

export default {
  props: {
    projectSchema: {
      type: String,
      required: true,
    },
    feature: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Property,
  },
  computed: {
    url() {
      return `v1/geofeatureproperties/${this.projectSchema}/${this.feature.layerName}`;
    },
  },
  methods: {
    getMappingName(mappings, propName) {
      const map = mappings.find((x) => x.columnName === propName);
      return map.fieldName;
    },
  },
};
</script>
